import React from 'react';

import ShelfShowView from '@shared/shelves/ShelfShowView'
import { useLoaderData } from 'react-router-dom'

import { shelfService } from '@services/admin/shelfService'

export default function AdminShelfShow() {
  const shelf = useLoaderData()

  return (
    <ShelfShowView
      shelf={shelf}
      role="admin"
      shelfService={shelfService}
    />
  )
}
